import React from "react";

function Copy() {
  return (
    <div>
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.215 3C25.0453 3 31.43 9.32447 31.43 17.215C31.43 25.0453 25.1055 31.43 17.215 31.43C9.3847 31.43 3 25.1055 3 17.215C3 9.3847 9.32447 3 17.215 3ZM17.215 4.20466C24.3827 4.20466 30.2253 10.0473 30.2253 17.215C30.2253 24.3827 24.3827 30.2253 17.215 30.2253C10.0473 30.2253 4.20466 24.3827 4.20466 17.215C4.20466 10.0473 10.0473 4.20466 17.215 4.20466Z"
          fill="black"
        />
        <path
          d="M15.2934 10C14.6946 10 14.2096 10.4925 14.2096 11.1005V19.9046C14.2096 20.5127 14.6946 21.0052 15.2934 21.0052H22.3384C22.9372 21.0052 23.4223 20.5127 23.4223 19.9046V13.5767C23.4223 13.4309 23.3654 13.2911 23.2635 13.1876L20.2829 10.1612C20.181 10.0578 20.0434 10 19.8998 10H15.2934ZM19.6288 11.0479L22.3903 13.8518H20.1707C19.8716 13.8518 19.6288 13.6053 19.6288 13.3015V11.0479ZM12.5838 12.7513C11.985 12.7513 11.5 13.2438 11.5 13.8518V22.6559C11.5 23.264 11.985 23.7565 12.5838 23.7565H19.6288C20.2276 23.7565 20.7127 23.264 20.7127 22.6559V22.1057H15.2934C14.098 22.1057 13.1258 21.1185 13.1258 19.9046V12.7513H12.5838Z"
          fill="black"
        />
      </svg>
    </div>
  );
}

export default Copy;
